export default {
  buttons: {
    back: 'Takaisin',
  },
};
